// Cupom do Fechar mesa / Finalizar retirada conferido de novo quando a rodada
// muda (marcou outro produto, pagou uma parte): o desconto depende dos produtos
// que estão sendo pagos, porque produto em promoção que não aceita cupom fica
// fora da conta (achado 412). Mesma ideia do Novo Pedido
// (features/novo-pedido-regras/useRevalidarCupom.js).
import axios from "axios";
import { useEffect, useRef } from "react";

import { assinaturaDaRodada } from "../lib/itensDoCupom";

const ESPERA_MS = 700;
const centavos = (v) => Math.round((Number(v) || 0) * 100);

/**
 * `cupom`: a resposta da validação que a tela guardou (ou null). `pausado`:
 * conta dividida — o desconto já está nas partes, não se confere.
 * `aplicar(resposta)` grava o cupom revalidado; `remover(motivo)` tira.
 */
export function useCupomDaRodada({ cupom, subtotal, itens, modulo, clienteId, clienteTelefone, pausado, aplicar, remover }) {
  const codigo = cupom?.code || null;
  const chave = codigo && !pausado && subtotal > 0 ? `${codigo}|${centavos(subtotal)}|${assinaturaDaRodada(itens)}` : null;
  const atual = useRef({});
  atual.current = { codigo, subtotal, itens, modulo, clienteId, clienteTelefone, aplicar, remover, chave, desconto: cupom?.discount };
  const conferida = useRef(null);
  const codigoVisto = useRef(null);

  useEffect(() => {
    // Cupom acabou de entrar: foi validado agora, com esta mesma rodada.
    if (codigo !== codigoVisto.current) {
      codigoVisto.current = codigo;
      conferida.current = chave;
      return undefined;
    }
    if (!chave || chave === conferida.current) return undefined;
    const t = setTimeout(async () => {
      const a = atual.current;
      let d;
      try {
        ({ data: d } = await axios.post("/api/coupons/validate", {
          code: a.codigo,
          order_total: a.subtotal,
          customer_id: a.clienteId || null,
          customer_phone: a.clienteTelefone || null,
          ...(a.modulo ? { modulo: a.modulo } : {}),
          ...(a.itens?.length ? { items: a.itens } : {}),
        }));
      } catch {
        return; // sem rede: fica o valor anterior
      }
      if (atual.current.chave !== a.chave) return; // mudou de novo no meio: outra conferência vem
      conferida.current = a.chave;
      if (d?.valid) {
        if (centavos(d.discount) !== centavos(a.desconto)) a.aplicar({ ...d, code: d.code || a.codigo });
        return;
      }
      a.remover(d?.message || d?.error || "não vale para o que está sendo pago");
    }, ESPERA_MS);
    return () => clearTimeout(t);
  }, [codigo, chave]);
}
